var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoconnectmgi2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.062,
    height: 33.562,
    viewBox: "0 0 138.062 33.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(-880.782 -273.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_798",
    transform: "translate(880.782 273.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1465",
    d: "M3.335,0H30.228a3.339,3.339,0,0,1,3.335,3.335V30.228a3.339,3.339,0,0,1-3.335,3.335H3.335A3.339,3.339,0,0,1,0,30.228V3.335A3.339,3.339,0,0,1,3.335,0Z",
    fill: "#004b93"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    transform: "translate(5.101 3.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne_1",
    d: "M91.249,106.325H90.6V95.6h.649Z",
    transform: "translate(-79.371 -81.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    d: "M118.858,101.025H114.19a1.188,1.188,0,0,1-1.19-1.19V95.6h.649v4.236a.542.542,0,0,0,.541.541h4.668Z",
    transform: "translate(-97.733 -81.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    d: "M44.168,101.025H39.5v-.649h4.668a.542.542,0,0,0,.541-.541V95.6h.649v4.236A1.212,1.212,0,0,1,44.168,101.025Z",
    transform: "translate(-37.481 -81.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    d: "M46.9,31.574a4.533,4.533,0,0,0,.018-9.066,4.432,4.432,0,0,0-1.6.288,6.276,6.276,0,0,0-12.473.775,4.762,4.762,0,0,0-.523-.036,4.02,4.02,0,1,0,0,8.039Z",
    transform: "translate(-28.3 -17.495)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 2.343,
    cy: 2.343,
    r: 2.343,
    transform: "translate(4.777 19.989)",
    fill: "#fbba00"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 2.343,
    cy: 2.343,
    r: 2.343,
    transform: "translate(14.33 25.613)",
    fill: "#98c226"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 2.343,
    cy: 2.343,
    r: 2.343,
    transform: "translate(24.279 19.989)",
    fill: "#0094cd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "C-3",
    transform: "translate(12.707 6.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M77.205,39.23l1.172.306a3.935,3.935,0,0,1-1.334,2.217,3.706,3.706,0,0,1-2.361.757,4.183,4.183,0,0,1-2.343-.595,3.679,3.679,0,0,1-1.37-1.694,6.155,6.155,0,0,1-.469-2.379,5.492,5.492,0,0,1,.523-2.433,3.74,3.74,0,0,1,1.514-1.568A4.378,4.378,0,0,1,74.7,33.3a3.716,3.716,0,0,1,2.253.685A3.49,3.49,0,0,1,78.215,35.9l-1.154.27a2.621,2.621,0,0,0-.9-1.406,2.442,2.442,0,0,0-1.478-.451,2.87,2.87,0,0,0-1.712.487A2.755,2.755,0,0,0,72,36.112a5.9,5.9,0,0,0,.054,3.7,2.4,2.4,0,0,0,1.027,1.262,2.988,2.988,0,0,0,1.514.415,2.523,2.523,0,0,0,1.676-.577A2.739,2.739,0,0,0,77.205,39.23Z",
    transform: "translate(-70.5 -33.3)",
    fill: "#004b93"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M7.524,17.18a6.4,6.4,0,0,0,5-2.106l-1.512-1.44A4.381,4.381,0,0,1,7.65,15.128,4.3,4.3,0,0,1,3.15,10.7a4.3,4.3,0,0,1,4.5-4.428,4.425,4.425,0,0,1,3.366,1.476l1.512-1.422A6.383,6.383,0,0,0,7.542,4.22,6.421,6.421,0,0,0,.792,10.7,6.416,6.416,0,0,0,7.524,17.18Zm12.87,0a6.487,6.487,0,1,0,0-12.96,6.487,6.487,0,1,0,0,12.96Zm0-2.052A4.294,4.294,0,0,1,15.966,10.7a4.294,4.294,0,0,1,4.428-4.428A4.294,4.294,0,0,1,24.822,10.7,4.294,4.294,0,0,1,20.394,15.128ZM38.538,4.4v8.532L31.59,4.4H29.664V17h2.322V8.468L38.934,17H40.86V4.4Zm14.58,0v8.532L46.17,4.4H44.244V17h2.322V8.468L53.514,17H55.44V4.4Zm8.046,10.638V11.564h6.084V9.638H61.164V6.362h6.858V4.4h-9.2V17h9.45V15.038Zm15.5,2.142a6.4,6.4,0,0,0,5-2.106l-1.512-1.44a4.381,4.381,0,0,1-3.366,1.494,4.3,4.3,0,0,1-4.5-4.428,4.3,4.3,0,0,1,4.5-4.428,4.425,4.425,0,0,1,3.366,1.476l1.512-1.422A6.817,6.817,0,0,0,69.93,10.7,6.416,6.416,0,0,0,76.662,17.18ZM86.328,17h2.34V6.38h4.176V4.4H82.152V6.38h4.176Z",
    transform: "translate(926 282)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoconnectmgi2);
export default __webpack_public_path__ + "static/media/logoconnectmgi2.f7d28fc228122c805906d6128c641041.svg";
export { ForwardRef as ReactComponent };